<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label class="control-label">{{ inputLabel }}</label>
    <div class="internal-comment-block">
      <div class="col-md-10">
        <input
            type="text"
            class="form-control"
            id="internal-comment-input"
            placeholder="Внутренний комментарий"
            v-model="inputValue"
        />
      </div>
      <div class="col-md-2">
        <button
            v-if="true"
            type="button"
            :disabled="disableButton"
            class="btn btn-success btn-primary-white hundred-percent-width"
            @click="addInternalComment"
        >Сохранить
        </button>
      </div>
    </div>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import { ApiClient } from '@/common/helpers/api-client/ApiClient';

export default {
  name: 'InternalCommentBlock',

  mixins: [
    applicationInputMixin,
    applicationFormMixin
  ],

  props: {
    inputName: {
      default: 'internal_comment'
    }
  },

  data: function() {
    return {
      oldValue: this.form.application.internal_comment
    };
  },

  methods: {
    addInternalComment () {
      this.requestAddInternalComment(this.inputValue, this.form.application.id)
    },

    async requestAddInternalComment (internalComment, applicationId) {
      await ApiClient.addInternalCommentRequest({
        internal_comment: internalComment,
        application_id: applicationId
      })
    }
  },

  computed: {
    disableButton() {
      return this.inputValue === this.oldValue
    }
  }
}
</script>
